/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const ONBOARD_OFFICER = gql`
mutation CreateOnboarding($organizationName: String!, $departmentName: String!, $officerEmail: String!, $officerFamilyName: String!, $officerGivenName: String!, $forceNo: String!, $rank: String!, $designation: String!) {
  createOnboarding(organizationName: $organizationName, departmentName: $departmentName, officerEmail: $officerEmail, officerFamilyName: $officerFamilyName, officerGivenName: $officerGivenName, forceNo: $forceNo, rank: $rank, designation: $designation) {
    organizationName
    departmentName
    officerEmail
    officerGivenName
    onBoardingStatus
    updatedAt
    createdAt
  }
}
`;

